let $ = require('jquery');
let Backbone = require("backbone");
let _ = require("underscore");
import MenuView from "./MenuView.js";
import BillItemListView from "./BillItemListView.js";
import BillItemEditView from "./BillItemEditView.js";
import TableSelectModalView from "../comp/TableSelectModalView.js";
import ModalView from "../comp/ModalView.js";
import POS from "../../POS.js";

let BasePagingModel = require("../../model/BasePagingModel.js");
import i18n from "../../utils/i18n";

let DbRecorder = require("../../recorder/DbRecorder.js");
let {LogUtil} = require("../../utils/utils.js");
import PrintService from "../../service/PrintService.js";

let main = function () {
    return Backbone.View.extend({

        billItemListView: null,
        menuView: null,
        billItemEditView: null,
        tableSelectListView: null,
        num: null,

        events: {
            "keyup": "fastSearchFromKeyboard",
            "click .tableSelectBtn": "onClickSelectTableButton",
            "click .bill-submit": "onClickSubmitBillButton",
            "click .btn-cancel": "toggleOrderPanel",
            "click .toTablePage": "toTablePage",
            "click .sc-confirm": "shortCodeConfirm",
            "click  .orderCol .add-note:not(.deletenote)": "addNote",
            "click .pay-notes .deletenote": "_removeNote",
            "click  .orderCol .add-booking:not(.deletebooking)": "_addBooking",
            "click .booking-notes .deletebooking": "_removeBooking",
            "click .search-panel": "searchItem",
            "click .search-box .close-search": "closeItem",
            "click .diner-level .quantity-editor .plus-btn": "plusNum",
            "click .diner-level .quantity-editor .minus-btn": "minusNum",
            "click .orderFooter .btn.confirm-order": "toggleOrderPanel",
        },

        getUnconfirmedItemCollection: function () {
            var _table = this.model.get("currentTable");
            if (_table) {
                if (_table.getCurrentBill().isCompleted() || _table.getCurrentBill().isPaid()) {
                    _table.createNewBill();
                }
                return _table.getCurrentBill().getUnconfirmedItems();
            }
            return null;
        },

        initialize: function (options) {
            var printerStatus = POS.getPrinterSetting().isPrintable();
            if (printerStatus) {
                this.$(".submit-bill").show();
                this.$(".checked-status").prop("checked", true);
            } else {
                this.$(".submit-bill").hide();
                this.$(".checked-status").prop("checked", false);
            }
            this.billItemListView = new BillItemListView({
                model: new BasePagingModel({
                    collection: this.getUnconfirmedItemCollection(),
                    symbol: POS.get("restaurantModel").get("currencySymbol")
                }),
                el: this.$('.orderLeft')
            });

            this.menuView = new MenuView({
                collection: POS.getMenu().getCategories().getAvailableCategories(),
                el: this.$('.orderMain')
            });

            this.billItemEditView = new BillItemEditView({el: this.$(".orderMain")});

            this.tableSelectModalView = new TableSelectModalView({
                collection: POS.get("tableCollection").unWebTables(),
                currentTable: this.model.get("currentTable")
            });
            this.num = new Backbone.Model({num: ""});
            this.listenTo(this.billItemListView, 'removeBillItem', this.onRemoveBillItem);
            this.listenTo(this.menuView, 'selectMenuItem', this.onSelectMenuItem);
            this.listenTo(this.billItemListView, "selectBillItem", this.onSelectBillItem);
            this.listenTo(this.billItemEditView, "close", this.onCloseBillItemEditView);
            this.listenTo(this.billItemEditView, 'changeNumber', this.onChangeBillItemNumber);
            this.listenTo(this.billItemListView, 'changeNumber', this.onChangeBillItemNumber);
            this.listenTo(this.billItemEditView, 'changeTag', this.onChangeTags);
            this.listenTo(this.billItemEditView, 'changeDiscount', this.onChangeDiscounts);
            this.listenTo(this.billItemEditView, 'selectMenuItem', this.onSelectMenuItem);
            this.listenTo(this.billItemEditView, 'removeTagMenuItem', function (tagMenuItem) {
                this.billItemListView.onRemove(tagMenuItem);
            });
            this.listenTo(this.billItemListView, "changePage", this.onChangePageOfBillItemList);
            this.listenTo(this.tableSelectModalView, "selectTable", this.onChangeTable);
        },

        fastSearchFromKeyboard: function (event) {
            // edited by FlyingAnt
            // if the keyboard event is not from global
            if ($(event.currentTarget).find('input.quantity').is(":focus")) {
                console.log("i'am focus");
                return false;
            }
            if ($(event.target).hasClass("search-input")) {
                this.menuView.query(this.$(".search-input").val());
                return false;
            }
            var currentQueryString = '';
            if (event.keyCode == 8) {
                // backspace touched
                currentQueryString = this.$(".search-input").val().substring(0, this.$(".search-input").val().length - 1);
            } else if (event.ctrlKey && ((105 >= event.keyCode && event.keyCode >= 96) || (57 >= event.keyCode && event.keyCode >= 48))) {
                if ((105 >= event.keyCode && event.keyCode >= 96)) {
                    this.num.set({num: this.num.get("num") + String.fromCharCode(event.keyCode - 48)});
                } else {
                    this.num.set({num: this.num.get("num") + String.fromCharCode(event.keyCode)});
                }
                return;
            } else if (event.keyCode == 17) {
                var amount = parseInt(this.num.get("num"));
                if (this.billItemListView.model.get("collection").first() && amount > 0) {
                    if (amount > 9999) {
                        amount = 9999;
                    }
                    this.billItemListView.model.get("collection").first().setQuantity(amount);
                    this.onChangeBillItemNumber();
                }
                this.num.set({num: ""});
                return;
            } else if (event.keyCode == 13) {
                $(".search-panel").css('display') != 'none' ? this.onClickSubmitBillButton() : this.shortCodeConfirm();
                return;
            } else if ((57 >= event.keyCode && event.keyCode >= 48) || (105 >= event.keyCode && event.keyCode >= 96)) {
                if ((105 >= event.keyCode && event.keyCode >= 96)) {
                    currentQueryString = this.$(".search-input").val() + String.fromCharCode(event.keyCode - 48);
                } else {
                    currentQueryString = this.$(".search-input").val() + String.fromCharCode(event.keyCode);
                }
            } else if (event.keyCode >= 65 && event.keyCode <= 90) {
                currentQueryString = this.$(".search-input").val() + String.fromCharCode(event.keyCode + 32);
            } else if (event.keyCode == 27) {
                currentQueryString = "";
            } else if (event.keyCode == 33) {
                if (this.menuView.$el.find('.paging').length > 0) {
                    this.menuView._prev();
                }
            } else if (event.keyCode == 34) {
                if (this.menuView.$el.find('.paging').length > 0) {
                    this.menuView._next();
                }
            } else {
                return
            }
            if (currentQueryString.length >= 1) {
                if ($('.search-box').hasClass('hidden')) {
                    $(".search-panel").click();
                }
                this.$(".search-input").val(currentQueryString);
                this.menuView.query(currentQueryString);
            } else if (currentQueryString.length == 0 && event.keyCode != 33 && event.keyCode != 34) {
                this.closeItem();
            }
        },
        onChangeTable: function (table) {
            window.location.hash = "order/" + table.id;
        },
        closeItem: function (evt) {
            $(".search-panel").show();
            var box = $(".search-box"), input = $(".search-input");
            $(".close-search").addClass("hidden");
            input.animate(
                {
                    width: 0
                }, 100);
            box.animate(
                {
                    width: 0
                }, 100, function () {
                    box.addClass("hidden");
                });
            this.$(".search-input").val('');
            this.menuView.query('');
        },
        searchItem: function (evt) {
            $(evt.currentTarget).hide();
            var box = $(".search-box"), input = $(".search-input");
            box.removeClass("hidden").animate(
                {
                    width: 300
                }, 100, function () {
                    $(".close-search").removeClass("hidden");
                });
            input.animate(
                {
                    width: 245
                }, 100);
        },
        //增加用餐人数
        plusNum: function () {
            var self = this, quantityInput = self.$(".quantity-input");
            var table = self.model.get('currentTable');
            var bill = table.getCurrentBill();
            var dinerCount = bill.get("dinerCount");
            if (dinerCount >= 99) {                                 //限制一个bill的最多用餐人数为99
                return;
            }
            quantityInput.val(dinerCount + 1);
            bill.set({dinerCount: dinerCount + 1}, {silent: true});
        },
        //减少用餐人数
        minusNum: function () {
            var self = this, quantityInput = self.$(".quantity-input");
            var table = self.model.get('currentTable');
            var bill = table.getCurrentBill();
            var dinerCount = bill.get("dinerCount");
            if (dinerCount <= 0) {                               //限制一个bill的最少用餐人数为0（0对应增加餐品的情况）
                return;
            }
            quantityInput.val(dinerCount - 1);
            bill.set("dinerCount", dinerCount - 1, {silent: true});
        },
        onChangePageOfBillItemList: function () {
            this.menuView.render();
        },

        onChangeDiscounts: function (billItem) {
            this.billItemListView.render();
            this.updateBillState();
        },

        onChangeTags: function () {
            this.billItemListView.render();
        },

        onRemoveBillItem: function () {
            analytics('send', 'event', 'Order', 'removeBillItem');
            this.menuView.render();
            this.updateBillState();
        },

        onChangeBillItemNumber: function () {
            this.billItemListView.render();
            this.updateBillState();
        },

        onCloseBillItemEditView: function () {
            this.menuView.render();
            this.billItemListView._hideItem();
        },

        render: function () {
            var showGuide = POS.checkBillAmount() == 0;
            $("#order").focus();
            var self = this;
            if (!this.model.get("currentTable")) {
                var tables = POS.getTables();
                if (tables.length == 1) {
                    this.model.set("currentTable", tables.first());
                }
            }
            if (!this.model.get("currentTable")) {
                this.tableSelectModalView.render();
            } else {
                this.billItemListView.model.set({
                    note: self.model.get("currentTable").getCurrentBill().get("note") ? self.model.get("currentTable").getCurrentBill().get("note") : "",
                    booking: self.model.get("currentTable").getCurrentBill().get("booking") ? self.model.get("currentTable").getCurrentBill().get("booking") : null,
                    collection: self.getUnconfirmedItemCollection(),
                    offset: 0,
                    currentPriority: self.model.get("currentTable").getCurrentBill().getMaxPriority()
                });
                this.billItemListView.render();
                this.menuView.render();
                this.updateBillState();
                this.updateTableState();
            }
            Intercom('trackEvent', '开始点餐');
            /*if (window.location.hash.indexOf("order") > 0 && showGuide && this.options.guideView.options.restStatus != "old") {
                this.options.guideView.model.clear({silent: true});
                this.options.guideView.model.set({
                    guideImage: "<img src=" + i18n.msg('pos.survey.step2.image') + ">"
                });
                this.options.guideView.$el.find('.guideImage').addClass('img-cursor-pointer');
            }*/
            return this;
        },

        onSelectMenuItem: function (params) {
            // analytics('send', 'event', 'Order', 'selectItem');
            if (this.model.get("currentTable").getCurrentBill().get("note")) {
                params.note = this.model.get("currentTable").getCurrentBill().get("note");
            }
            console.log(params);
            var billItemModel = this.billItemListView.addItem(params);
            this.getUnconfirmedItemCollection().add(billItemModel, {at: 0});
            this.updateBillState();
        },

        onSelectBillItem: function (billItem, status) {
            if (status == 'close') {
                this.menuView.render();
            } else {
                if (billItem) {
                    this.billItemEditView.model = billItem;
                    this.billItemEditView.model.set({symbol: POS.get("restaurantModel").get("currencySymbol")});
                    this.billItemEditView.render();
                }
            }
        },

        updateBillState: function () {
            var currentTable = this.model.get("currentTable");
            if (currentTable) {
                var totalPrice = currentTable.getCurrentBill().getUnconfirmedTotal();

                if (POS.get("restaurantModel").get("currencySymbol")) {
                    this.$(".symbol").html(POS.get("restaurantModel").get("currencySymbol"));
                }
                this.$(".totalPrice").html(totalPrice.toFixed(2));
                if (currentTable.getCurrentBill().get('dinerCount')) {
                    this.$(".quantity-input").val(currentTable.getCurrentBill().get('dinerCount'));
                } else {
                    this.$(".quantity-input").val(0);
                }
                console.log('unconfirmed quantity: ', currentTable.getCurrentBill().getUnconfirmedQuantity());
                this.$(".orderFooter .itemCount").addClass("animated rubberBand").text(currentTable.getCurrentBill().getUnconfirmedQuantity());
                _.delay(() => {
                    this.$(".orderFooter .itemCount").removeClass("animated rubberBand");
                }, 1000);
            }
        },

        updateTableState: function () {
            var table = this.model.get("currentTable");
            if (table) {
                this.$(".tableName").html(table.get("name"));
                this.$(".tableSelectBtn").html(i18n.msg("pos.order.table.change"));
            } else {
                this.$(".tableSelectBtn").html(i18n.msg("pos.order.table.select"));
            }
        },

        onClickSelectTableButton: function (event) {
            analytics('send', 'event', 'Order', 'selectTable', POS.getRestaurant().get('name'));
            LogUtil.info('OrderView', 'selectTable');

            this.tableSelectModalView.render(this.model.get('currentTable'));
        },

        showLoading: function (isShown) {
            if (isShown) {
                $('#bigLoading').removeClass('hidden');
            } else {
                $('#bigLoading').addClass('hidden');
            }
        },

        onClickSubmitBillButton: function (event) {
            console.log("OrderView.onClickSubmitBillButton", event);
            var self = this;
            this.showLoading(true);
            var restaurant = POS.get("restaurantModel");
            this.toggleOrderPanel();
            _.defer(_.bind(function () {
                    if (self.processing) {
                        this.showLoading(false);
                        return;
                    }

                    self.processing = true;
                    var table = self.model.get("currentTable");

                    if (!table) {
                        this.showLoading(false);
                        alert(i18n.msg("pos.order.bill.submit.must.select.table"));
                        this.processing = false;
                        return;
                    }

                    if (table.getCurrentBill().getUnconfirmedItems().length === 0) {
                        this.showLoading(false);
                        alert(i18n.msg("pos.order.bill.submit.must.select.billitem"));
                        this.processing = false;
                        return;
                    }

                    var bill, billDetail, result;
                    bill = table.getCurrentBill();
                    //限制每个账单所点餐品数量
                    var orderCount = 0;
                    bill.getConfirmedItems().forEach(function (confirmedItem) {
                        orderCount += confirmedItem.getOrderedQuantity();
                    });
                    bill.getUnconfirmedItems().forEach(function (unConfirmedItem) {
                        orderCount += unConfirmedItem.getOrderedQuantity();
                    });
                    if (orderCount > 9999) {
                        this.showLoading(false);
                        alert(i18n.msg("pos.order.items.quantity.limitAlert"));
                        this.processing = false;
                        return;
                    } else {
                        var unConfirmItems = DbRecorder.convert2JSON(bill.getUnconfirmedItems());
                        var unConfirmTotal = bill.getUnconfirmedTotal();
                        var billLength = bill.getBillItems().length;
                        // var offlineMsg = i18n.msg("pos.membership.offline");
                        // if (!DbRecorder.getStatusModel().get("online")) {
                        //     new ModalView({
                        //         hideFooter: true,
                        //         body: "<h1 class='large' style='color: white; text-align: center;'>" + offlineMsg + "</h1>"
                        //     }).render();
                        //     return;
                        // }
                        // const result = $.post('/menuItemSoldOutRule/check',
                        //     {
                        //         rId: POS.getRestaurant().id,
                        //         jsonOrders: JSON.stringify(_.map(bill.getUnconfirmedItems().models, function (item) {
                        //             return item.toJSON()
                        //         }))
                        //     });
                        //
                        // POS.showLoading(true);
                        // result.done(function (data) {
                        //     console.log("menuItemSoldOutRule checked ", data);
                        //     if (data.success) {
                        table.submitBill();
                        bill.set("restaurant", DbRecorder.convert2JSON(restaurant));
                        bill.calculateAmount();
                        bill.resetCheckInTime();
                        bill.setOrderDate();
                        if (billLength === 0) {
                            var serial = parseInt(table.get('billCounts'));
                            serial++;
                            bill.set({serial: serial});
                            table.set({billCounts: serial});
                            console.log("bill" + bill.id + "bill serial is " + serial);
                        }
                        billDetail = DbRecorder.convert2JSON(bill);
                        billDetail.sid = bill.getSID();
                        billDetail.table = table.toJSON();
                        billDetail.uitems = unConfirmItems;
                        billDetail.uAmount = unConfirmTotal;
                        // 提交订单
                        self._orderPrint(billDetail);
                        this.billItemListView.model.set({
                            collection: this.getUnconfirmedItemCollection(),
                            offset: 0
                        });
                        if (POS.getRestaurant().get("goCashier")) {
                            window.location.hash = "cashier/" + table.id + "/" + (bill.id ? bill.id : 0);
                        } else {
                            window.location.hash = "table/" + table.id;
                            window.location.hash = "table/" + table.id;
                        }
                        delete self.processing;
                        POS.showLoading(false);
                        // } else {
                        //     alert(data.errors.menuItem);
                        //     return;
                        // }
                        // }.bind(this));

                        // result.fail(function (res) {
                        //     console.log("menuItemSoldOutRule fail ", res);
                        // }.bind(this));
                        //
                        // result.always(function () {
                        //     delete self.processing;
                        //     POS.showLoading(false);
                        // }.bind(this));
                    }

                    console.log("after menuItemSoldOutRule");
                }, this)
            );
        },


        _orderPrint: function (billDetail) {
            var printSetting = POS.getPrinterSetting();
            if (printSetting.get("orderReceipt")) {
                PrintService.printOrderReceipt(billDetail, true);
            }
            if (printSetting.get("dispatchSlip")) {
                PrintService.printDispatchReceipt(billDetail, 'dispatch', true);
            } else {
                PrintService.printAndroidDeviceDispatch(billDetail, 'dispatch', true);
            }
            if (printSetting.get("itemSlip")) {
                PrintService.printItemsReceipts(billDetail, null, true);
            } else {
                PrintService.printAndroidDeviceItems(billDetail, null, true);
            }
            if (printSetting.get("tagSlip")) {
                PrintService.printTagReceipts(billDetail, null, true);
            }

        },
        /**
         * Go to table page
         * -- You cannot nav to table page by clicking in Overview if table is empty.
         * -- So here offers an entrance for empty table.
         */
        toTablePage: function () {
            Backbone.history.navigate("etable/" + this.model.get("currentTable").get("id"), {trigger: true});
        },

        shortCodeConfirm: function () {
            var self = this, scInput = self.$(".search-input");
            self.menuView.confirmFirst();
            scInput.val("");
            self.menuView.query(scInput.val());
            this.closeItem();
        },
        addNote: function () {
            LogUtil.info('CashierView', 'showAddNotes');
            var offlineMsg = i18n.msg("pos.note.offline");
            if (!DbRecorder.getStatusModel().get("online")) {
                new ModalView({
                    hideFooter: true,
                    body: "<h1 class='large' style='color: white; text-align: center;'>" + offlineMsg + "</h1>"
                }).render();
                return;
            } else {
                this.noteSelectorView = this.noteview;
                this.noteSelectorView.once("noteSelected", function (note) {
                    var displayNote = note.note;
                    self.model.get("currentTable").getCurrentBill().set({
                        note: note.note,
                        noteBytes: note.noteBytes
                    });
                    self.note = note.note;
                    self.noteSelectorView.$el.modal("hide");
                    self.$(".add-btn").hide();
                    self.$(".pay-notes").show().css('display', 'block').find(".content").text(note.note).show();
                    self.noteSelectorView.clear();
                    self.billItemListView.model.set({
                        note: self.model.get("currentTable").getCurrentBill().get("note") ? self.model.get("currentTable").getCurrentBill().get("note") : ""
                    });
                });
                var self = this;

                this.note = "";
                this.noteSelectorView.$el.modal("show");
                $("textarea.note").val(this.model.get("currentTable").getCurrentBill().get("note"));
            }
        },
        _removeNote: function (event) {
            this.note = null;
            this.model.get("currentTable").getCurrentBill().set({note: null, noteBytes: null});
            $(event.currentTarget).closest(".pay-notes").hide().siblings('.add-btn').show();
            this.billItemListView.model.set({
                note: null
            });
            return false;
        },
        _removeBooking: function (event) {
            this.booking = null;
            this.model.get("currentTable").getCurrentBill().set({booking: null, bookingId: null});
            $(event.currentTarget).closest(".booking-notes").hide().siblings('.booking-btn').show();
            this.billItemListView.model.set({
                booking: null
            });
            return false;
        },

        toggleOrderPanel: function () {
            this.$('.orderMain').toggleClass('minimize');
            this.$('.leftPanel').toggleClass('expanded');
            this.$('.orderFooter').toggleClass('minimize');
        }
    })
        ;

};

let exportedValue = main();

export default exportedValue;



// WEBPACK FOOTER //
// ./src/view/order/OrderView.js